<ion-app class="app__wrapper">
  <ion-router-outlet *ngIf="ready"></ion-router-outlet>
  <app-loader [full]="true" [loading]="true" *ngIf="!ready"></app-loader>
</ion-app>
